var app = require('../manager-module.js');

app.factory('serviceforex', function() {
  return "hello";
});

module.exports = app;



//////////////////
// WEBPACK FOOTER
// ./app/js/services/forex.js
// module id = 220
// module chunks = 0